import colorsDefault from './colors_default.json';
import colors1 from './tema 1_Magenta Royale.json';
import colors2 from './tema 2_Citrus Meadow.json';
import colors3 from './tema 3_Tropical Dreams.json';
import colors4 from './tema 4_Skyline.json';
import colors5 from './tema 5_Berry Glow.json';
import colors6 from './tema 6_Scarlet Wine.json';
import colors7 from './tema 7_Neutral.json';
import colors8 from './tema 8_Golden Hour.json';

const all = [colorsDefault, colors1, colors2, colors3, colors4, colors5, colors6, colors7, colors8];

export { colorsDefault, colors1, colors2, colors3, colors4, colors5, colors6, colors7, colors8, all };

export default all;
